import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Container,
  Typography,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiGetRequest,
  apiDeleteRequest,
  apiDownloadFileData,
} from "src/utils/api/api";
import { addStatusBasedOnBooleanField } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import fileDownload from "js-file-download";
import DeleteIcon from "@material-ui/icons/Delete";
import { kmMessages, kmSystemLabels } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row, customHandlers) => {
  return (
    <Box display="flex" alignItems="flex-start" flexDirection="column">
      <Tooltip title="Edytuj">
        <IconButton
          aria-label="edytuj"
          component={RouterLink}
          onClick={() => customHandlers.setGlobalViewProperties()}
          to={`/uzytkownicy/edytujuzytk/${row.id}`}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Usuń">
        <IconButton
          aria-label="usuń"
          onClick={() => customHandlers.deleteHandler(row)}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const Users = ({
  globalData,
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setViewProperties,
  resetViewProperties,
}) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [deletedUser, setDeletedUser] = useState(null);
  const [orderBy, setOrderBy] = useState(
    globalData.viewProperties?.orderBy
      ? globalData.viewProperties.orderBy
      : null
  );
  const [order, setOrder] = useState(
    globalData.viewProperties?.order ? globalData.viewProperties.order : null
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    globalData.viewProperties?.rowsPerPage
      ? globalData.viewProperties.rowsPerPage
      : null
  );
  const [rowsPage, setRowsPage] = useState(
    globalData.viewProperties?.page ? globalData.viewProperties.page : null
  );
  const [selOrderBy, setSelOrderBy] = useState(null);
  const [selOrder, setSelOrder] = useState(null);
  const [selRowsPerPage, setSelRowsPerPage] = useState(null);
  const [selRowsPage, setSelRowsPage] = useState(null);

  const [dialogOpen, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    // resetViewProperties();
    apiGetRequest(apiEndpoints.getUsers.path, true)
      .then((data) => {
        disableGlobalLoader();

        setRows(
          addStatusBasedOnBooleanField(data, "active", [
            "Aktywny",
            "Zablokowany",
          ])
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const deleteHandler = (row) => {
    setDeletedUser(row);
    handleClickOpen();
  };

  const setGlobalViewProperties = () => {
    setViewProperties({
      view: "users",
      order: selOrder ? selOrder : order,
      orderBy: selOrderBy ? selOrderBy : orderBy,
      page: selRowsPage ? selRowsPage : rowsPage,
      rowsPerPage: selRowsPerPage ? selRowsPerPage : rowsPerPage,
    });
  };

  const headCells = [
    {
      id: "lp",
      numeric: false,
      lp: true,
      disablePadding: false,
      sortable: false,
      main: false,
      label: "L.p.",
      width: "1%",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: true,
      searchable: false,
      sortable: false,
      customHandlers: { deleteHandler, setGlobalViewProperties },
      component: RowButtons,
      width: "1%",
    },
    {
      id: "username",
      numeric: false,
      disablePadding: true,
      fieldName: "username",
      sortable: true,
      main: true,
      label: "Login",
      width: "13%",
    },
    {
      id: "firstName",
      numeric: false,
      disablePadding: true,
      fieldName: "firstName",
      sortable: true,
      main: false,
      label: "Imię",
      width: "5%",
    },
    {
      id: "lastName",
      numeric: false,
      disablePadding: true,
      fieldName: "lastName",
      sortable: true,
      main: false,
      label: "Nazwisko",
      width: "5%",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: true,
      fieldName: "email",
      sortable: true,
      main: false,
      label: "E-mail",
      width: "10%",
    },
    {
      id: "profiles",
      numeric: false,
      disablePadding: true,
      fieldName: "profiles",
      sortable: true,
      main: false,
      label: "Profile",
      dataType: 1,
      width: "15%",
    },
    {
      id: "institution",
      numeric: false,
      disablePadding: true,
      fieldName: "institution",
      sortable: true,
      main: false,
      label: "Instytucja",
      width: "15%",
    },
    {
      id: "function",
      numeric: false,
      disablePadding: true,
      fieldName: "function",
      sortable: true,
      main: false,
      label: "Funkcja",
      width: "5%",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      fieldName: "status",
      sortable: true,
      main: false,
      label: "Status",
      dataType: 0,
      width: "5%",
    },
    {
      id: "activeUntil",
      numeric: false,
      disablePadding: true,
      fieldName: "activeUntil",
      sortable: true,
      main: false,
      label: "Data aktywności",
      width: "5%",
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: true,
      fieldName: "createdAt",
      sortable: true,
      main: false,
      label: "Data rejestracji",
      width: "5%",
    },
    {
      id: "updatedAt",
      numeric: false,
      disablePadding: true,
      fieldName: "updatedAt",
      sortable: true,
      main: false,
      label: "Data modyfikacji",
      width: "5%",
    },
    {
      id: "lastLogin",
      numeric: false,
      disablePadding: true,
      fieldName: "lastLogin",
      sortable: true,
      main: false,
      label: "Data ostat. logowania",
      width: "5%",
    },
    {
      id: "blockedSince",
      numeric: false,
      disablePadding: true,
      fieldName: "blockedSince",
      sortable: true,
      main: false,
      label: "Data zablokowania",
      width: "5%",
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);
    apiDeleteRequest(apiEndpoints.deleteUser.path, { id: deletedUser.id }, true)
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response) {
          if (error.response.status === 401) {
            setLogoutUser();
          } else if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "ERROR_SUPERADMIN_USER") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.users.superuser_delete,
              });
            } else if (error.response.data.code === "ERROR_USER_HAS_VOTES") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.users.voted_user_delete,
              });
            } else if (error.response.data.code === "ERROR_USER_HAS_EMAILS") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.users.emails_user_delete,
              });
            }
          }
        }
      });
  };

  const handleExport = () => {
    apiDownloadFileData(`${apiEndpoints.getUsersExcel.path}`, true).then(
      (result) => {
        fileDownload(result, `Użytkownicy KM ${kmSystemLabels.programShortcut[globalData.systemInfo.fundProgram]}.xls`);
      }
    );
  };

  const handleExportConsent = () => {
    apiDownloadFileData(`${apiEndpoints.getUsersConsentExcel.path}`, true).then(
      (result) => {
        fileDownload(result, `Akceptacje użytkowników KM ${kmSystemLabels.programShortcut[globalData.systemInfo.fundProgram]}.xls`);
      }
    );
  };

  const setLocSelOrderBy = (inpOrderBy) => {
    console.log("setLocSelOrderBy");
    console.log(inpOrderBy);

    setSelOrderBy(inpOrderBy);
  };

  const setLocSelOrder = (inpOrder) => {
    console.log("setLocSelOrder");
    console.log(inpOrder);

    setSelOrder(inpOrder);
  };

  const setLocSelRowsPerPage = (inpRowsPerPage) => {
    console.log("setLocSelRowsPerPage");
    console.log(inpRowsPerPage);

    setSelRowsPerPage(inpRowsPerPage);
  };

  const setLocSelRowsPage = (inpRowsPage) => {
    console.log("setLocSelRowsPage");
    console.log(inpRowsPage);

    setSelRowsPage(inpRowsPage);
  };

  return (
    <Page className={classes.root} title="Użytkownicy">
      <KmPageTitle>Użytkownicy</KmPageTitle>
      <Container maxWidth={false}>
        <Toolbar
          dialogHandler={handleClickOpen}
          exportHandler={handleExport}
          exportConsentHandler={handleExportConsent}
        />
        <Box mt={3}>
          <KmFilteredTable
            markable={false}
            headCells={headCells}
            rows={rows}
            defaultOrderBy={orderBy}
            defaultOrder={order}
            defaultRowsPerPage={rowsPerPage}
            defaultPage={rowsPage}
            onSelectOrderBy={setLocSelOrderBy}
            onSelectOrder={setLocSelOrder}
            onSelectRowsPerPage={setLocSelRowsPerPage}
            onSelectPage={setLocSelRowsPage}
          />
          <Dialog
            fullScreen={fullScreen}
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {"Usuwanie użytkowników"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Czy na na pewno chcesz usunąć użytkownika `
                {deletedUser ? deletedUser.username : "-"}`?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
                Nie
              </Button>
              <Button onClick={handleDelete} color="primary" autoFocus>
                Tak
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
  setViewProperties: (viewProperties) =>
    dispatch(actions.setViewProperties(viewProperties)),
  resetViewProperties: () => dispatch(actions.resetViewProperties()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);
